import { useMemo } from "react";
import { useSessionContext } from "@/contexts/SessionContext";

export function useCustomer() {
  const ctx = useSessionContext();
  return useMemo(
    () => ({
      customer: ctx.session.customer,
      updateCustomerData: ctx.updateCustomerData,
      setGeolocation: ctx.setGeolocation,
      setLastCoordinates: ctx.setLastCoordinates,
      setSelectedAddress: ctx.setSelectedAddress,
      addAddress: ctx.addAddress,
      updateAddress: ctx.updateAddress,
      removeAddress: ctx.removeAddress,
      addVehicle: ctx.addVehicle,
      removeVehicle: ctx.removeVehicle,
    }),
    [ctx.session.customer, ctx.updateCustomerData, ctx.setGeolocation, ctx.setLastCoordinates, ctx.setSelectedAddress, ctx.addAddress, ctx.updateAddress, ctx.removeAddress, ctx.addVehicle, ctx.removeVehicle]
  );
}
